<template>
    <div>
        <v-layout row justify-end>
            <v-dialog v-model="dialog" persistent max-width="700px">
                <v-avatar dark color="primary" slot="activator">
                    <v-icon color="white">group</v-icon>
                </v-avatar>
                <v-card>
                    <v-card-title>
                        <span class="headline">Ügyfél keresése</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap row>
                                <v-flex :class="ugyfel.nem != 3 ? 'md2' : 'md6'">
                                    <v-select
                                            v-model="ugyfel.nem"
                                            label="Neme"
                                            item-text="value"
                                            item-value="key"
                                            :items="nem"
                                    ></v-select>
                                </v-flex>
                                <v-flex md4>
                                    <v-text-field v-model="ugyfel.nev" label="Név"></v-text-field>
                                </v-flex>
                                <v-flex v-if="ugyfel.nem != 3" md4>
                                    <v-text-field
                                            v-model="ugyfel.szulido"
                                            label="Születési idő"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md2>
                                    <v-btn class="button" @click="ugyfelKeres()"> Keresés</v-btn>
                                </v-flex>
                                <v-layout column>
                                    <v-flex v-for="(ugyfel, index) in ugyfelLista" :key="index">
                                        <v-layout align-center align-content-center row>
                                            <v-flex>
                                                <v-btn class="button" @click="selectUgyfel(ugyfel)"> Betölt</v-btn>
                                            </v-flex>
                                            <v-flex> {{ ugyfel.nev }}</v-flex>
                                            <v-flex> {{ ugyfel.cim }}</v-flex>
                                            <v-flex> {{ ugyfel.szulido }}</v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-flex md12>
                                    <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button" color="blue darken-1" text @click.native="dialog = false">Mégse</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>
<script>
import ugyfelTorzsService from '../../services/UgyfeltorzsService';
import DateFormat from '../../utils/DateFormat';

export default {
    data: () => ({
        dialog: false,
        loading: false,
        ugyfel: {
            nem: '',
            nev: '',
            szulido: '',
        },
        nem: [
            { key: 1, value: 'Férfi' },
            { key: 2, value: 'Nő' },
            { key: 3, value: 'Nem természetes személy' },
        ],
        ugyfelLista: [],
    }),

    methods: {
        ugyfelKeres() {
            this.loading = true;
            ugyfelTorzsService.getUgyfelLista_DEPRECATED(
                DateFormat.plainToDashed(this.ugyfel.szulido),
                null,
                10,
                this.ugyfel.nem,
                this.ugyfel.nev,
                1,
            ).then((response) => {
                this.ugyfelLista = response.data.data;
                this.loading = false;
            });
        },
        selectUgyfel(ugyfel) {
            /* eslint-disable-next-line eqeqeq */
            if (ugyfel.ugyfnem == 3) {
                this.$store.commit('updateSzerzodo', {
                    nem: ugyfel.ugyfnem,
                    ugyfazon: ugyfel.ugyfazon,
                    cegnev: ugyfel.cegnev,
                });
            } else {
                this.$store.commit('updateSzerzodo', {
                    szuletesi_ido: ugyfel.szulido,
                    nev: ugyfel.nev,
                    titulus: ugyfel.titulis,
                    nem: ugyfel.ugyfnem,
                    ugyfazon: ugyfel.ugyfazon,
                });
            }

            this.dialog = false;
        },
    },
};
</script>
<style scoped>
    .snackbar {
        font-size: 20px;
    }
</style>
